<template>
    <div>
        <a href="#" class="text-red-500 py-1 px-2 shadow-md border border-red-500 rounded-full inline-flex items-center" @click="show = true">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 p-1">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                </svg> 
                Disclaimer and POPIA Notice
        </a>
        <m-dialog width="420px" heading="Disclaimer and POPIA Notice" :show="show" @close="show = false">
            <template>
                <p class="text-sm py-1"> Disclaimer.  This report contains information gathered from our suppliers and we do not make any representations about the accuracy of the data displayed nor do we accept responsibility for inaccurate data. The company will not be liable for any damage caused by reliance on this report. This report is subject to the terms and conditions of the company as initially agreed upon.</p>
                <p class="text-sm text-red-500 py-1"> POPIA Notice: No data may be transferred or shared with a third party, and is for use within your organisation or branch as defined by the POPI act. You are required to keep the information confidential and may be criminally prosecuted for not complying with the POPI act. </p>
            </template>
            <template v-slot:footer>
                <div class="btn btn-primary" @click="show = false">Close</div>
            </template>
        </m-dialog>
    </div>
</template>
<script>
import Dialog from "@/components/dialog.vue";

export default {
    components: {Dialog},
    data() {
        return {
            show: false
        }
    }
}
</script>
